/**
 * Separation Reports + Statutory Exit Excel exports API client.
 *
 * Backend: app/api/routers/separation_reports.py — mounted at /hr/separation-reports.
 */
import apiClient from '@/shared/api/client'

export interface ReportDescriptor {
  key: string
  label: string
  needs_date_range?: boolean
}

const BASE = '/hr/separation-reports'

export const separationReportsApi = {
  list: async () => (await apiClient.get<ReportDescriptor[]>(`${BASE}/list`)).data,

  run: async (
    report_key: string,
    params: { from_date?: string; to_date?: string } = {},
  ) =>
    (await apiClient.get<Record<string, unknown>[]>(
      `${BASE}/run/${report_key}`,
      { params },
    )).data,

  exportEpfoForm10: async (status: string = 'DATA_READY') =>
    apiClient.get(`${BASE}/export/epfo-form10`, {
      params: { status },
      responseType: 'blob',
    }),

  exportEsiExit: async (status: string = 'DATA_READY') =>
    apiClient.get(`${BASE}/export/esi-exit`, {
      params: { status },
      responseType: 'blob',
    }),
}

/** Helper: trigger a browser download from a blob response. */
export function downloadBlob(
  response: { data: Blob | unknown; headers: Record<string, unknown> | unknown },
  fallbackName: string,
) {
  const headers = (response.headers ?? {}) as Record<string, unknown>
  const cdRaw = headers['content-disposition'] ?? headers['Content-Disposition'] ?? ''
  const cd = typeof cdRaw === 'string' ? cdRaw : ''
  const m = /filename="?([^";]+)"?/.exec(cd)
  const name = m?.[1] || fallbackName
  const blob = response.data instanceof Blob
    ? response.data
    : new Blob([response.data as BlobPart])
  const url = window.URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = name
  document.body.appendChild(a)
  a.click()
  a.remove()
  window.URL.revokeObjectURL(url)
}
